export const Panel = () => null;